import Paper from "@mui/material/Paper";
import { MenuProps } from "react-select";
import { SelectOption } from "./types";

export function Menu({
  children,
  innerProps,
  selectProps,
}: MenuProps<SelectOption>) {
  const { key: menuKey, ...restInnerProps } = innerProps ?? {};
  return (
    <Paper
      key={menuKey}
      className={selectProps.classes.paper}
      square
      {...restInnerProps}
    >
      {children}
    </Paper>
  );
}
